<script setup lang="ts">
const orderHistory = useOrderHistoryStore()
const userStore = useUserStore()

const localePath = useLocalePath()
const router = useRoute()
const currentTab = ref(router.path)

const categoryMenuItems = useCategoryMenuItems()

const menuItems = computed(() => {
  const items: any[] = []

  if (orderHistory.totalOrders > 0) {
    items.push({
      to: localePath('/order-history'),
      i18nKey: 'orderHistory.title',
    })
  }

  if (userStore?.data?.clinicChain) {
    items.push({
      to: localePath('/clinic-chain'),
      label: userStore.data.clinicChain.name,
    })
  }

  for (const cat of categoryMenuItems.value) {
    items.push({ to: cat.to, label: cat.label })
  }

  items.push({
    i18nKey: 'layout.menuSecondary.suppliers',
    to: localePath('/suppliers'),
  })
  items.push({
    to: localePath('/product-favorites'),
    i18nKey: 'layout.menuSecondary.productFavorites',
  })

  items.push({
    to: localePath('/campaigns'),
    i18nKey: 'layout.menuSecondary.campaigns',
  })

  return items
})
</script>

<template>
  <div class="secondary-menu-wrapper">
    <v-container class="d-flex justify-space-between align-center pa-0">
      <v-tabs
        v-model="currentTab"
        class="menu-secondary"
        center-active
        show-arrows
        hide-slider
        height="56"
      >
        <v-tab
          v-for="(item, index) in menuItems"
          :key="index"
          variant="plain"
          size="large"
          class="menu-secondary__tab text-medium-emphasis px-2"
          :href="!item.to && item.path ? item.path : null"
          :to="item.to ? item.to : null"
          :value="item.path || item.to"
          data-nav-id="nav_menu_secondary"
          :ripple="false"
          style="opacity: 1;"
        >
          <span v-if="item.i18nKey">{{ $t(item.i18nKey) }}</span>
          <span v-else>{{ item.label }}</span>
        </v-tab>
      </v-tabs>

      <section v-if="userStore?.data?.clinicShortName" class="mr-8">
        <span>{{ userStore.data.clinicShortName }}</span>
      </section>
    </v-container>
  </div>
</template>

<style scoped>
.secondary-menu-wrapper {
  height: 56px;
  background-color: white;
  position: sticky;
  top: 80px;
  z-index: 100;
}
a,
button {
  color: rgb(var(--v-theme-black-800)) !important;
  letter-spacing: 0px;
  font-weight: 400;
}
</style>
